module.exports = __webpack_public_path__ + "img/21.c02f898b.png";